import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { normalizeBrowserLanguage } from "./helpers/utils/i18n.util";
import { host } from "./helpers/services/request";

const langDetectorOptions = {
  // order and from where user language should be detected
  order: ["localStorage", "navigator"],
  // only detect languages that are in the whitelist
  checkWhitelist: true,
};

const options = {
  // debug: true,
  fallbackLng: "en",
  lngWhitelist: ["de-DE", "en-US"],
  detection: langDetectorOptions,
  load: "languageOnly",
  // have a common namespace used around the full app
  // ns: ["translations"],
  // defaultNS: "translations",
  saveMissing: false,
  // parseMissingKeyHandler: (key) => `${key}-missing`,
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
    format: (value, format, _lng) => {
      if (format === "uppercase") return value.toUpperCase();
      return value;
    },
  },
  wait: process && !process.release,
  backend: {
    loadPath: (language) =>
      `${host}/stateless/translations?lang=${normalizeBrowserLanguage(language[0])}`,
  },
  react: {
    useSuspense: false,
  },
};

// for browser use xhr backend to load translations and browser lng detector
if (process && !process.release) {
  i18n.use(Backend).use(LanguageDetector).use(initReactI18next);
}

// initialize if not already initialized
if (!i18n.isInitialized) {
  i18n.init(options);
}

export default i18n;
